export enum TSAuthEvent {
    LOGIN_SUCCESS = <any> 'LOGIN_SUCCESS',
    LOGIN_FAILED = <any> 'LOGIN_FAILED',
    LOGOUT_SUCCESS = <any> 'LOGOUT_SUCCESS',
    LOGOUT_FAILED = <any> 'LOGOUT_FAILED',
    NOT_AUTHENTICATED = <any> 'NOT_AUTHENTICATED',
    NOT_AUTHORISED  = <any> 'NOT_AUTHORISED',
    CHANGE_USER  = <any> 'CHANGE_USER'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/TSAuthEvent.ts